export default {
  path: '/ams',
  component: (resolve) => require(['@/views/ams/index.vue'], resolve),
  redirect: '/ams/asset-management/devices/bare-metal',
  children: [
    {
      path: '/ams/asset-management/devices',
      component: (resolve) => require(['@/views/ams/asset-management/devices/index.vue'], resolve),
      children: [
        {
          path: '/ams/asset-management/devices/bare-metal',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/bare-metal/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/bare-metal/:bareMetalId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/bare-metal/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/firewalls',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/firewall/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/firewalls/:firewallId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/firewall/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/switches',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/switch/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/switches/:switchId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/switch/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/routers',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/router/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/routers/:routerId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/router/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/kvms',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/kvm/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/kvms/:kvmId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/kvm/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/kvm-switches',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/kvm-switches/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/kvm-switches/:kvmSwitchId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/kvm-switches/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/drives',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/drive/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/drives/:driveId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/drive/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/powers',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/power/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/powers/:powerId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/power/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/racks',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/rack/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/racks/:rackId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/rack/detail/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/devices/gpu-cards',
          component: (resolve) =>
            require(['@/views/ams/asset-management/devices/gpucard/index.vue'], resolve)
        }
      ]
    },
    {
      path: '/ams/asset-management/ip-management',
      component: (resolve) =>
        require(['@/views/ams/asset-management/ip-management/index.vue'], resolve),
      children: [
        {
          path: '/ams/asset-management/ip-management/vlan',
          component: (resolve) =>
            require(['@/views/ams/asset-management/ip-management/vlan/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/ip-management/vlan/:vlanId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/ip-management/vlan/Detail.vue'], resolve)
        },
        {
          path: '/ams/asset-management/ip-management/prefixes',
          component: (resolve) =>
            require(['@/views/ams/asset-management/ip-management/prefixes/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/ip-management/prefixes/:prefixId',
          component: (resolve) =>
            require([
              '@/views/ams/asset-management/ip-management/prefixes/detail/index.vue'
            ], resolve)
        },
        {
          path: '/ams/asset-management/ip-management/ips',
          component: (resolve) =>
            require(['@/views/ams/asset-management/ip-management/IPs/index.vue'], resolve)
        },
        {
          path: '/ams/asset-management/ip-management/ips/:ipId',
          component: (resolve) =>
            require(['@/views/ams/asset-management/ip-management/IPs/detail/index.vue'], resolve)
        }
      ]
    },
    {
      path: '/ams/asset-management/data-centers',
      component: (resolve) =>
        require(['@/views/ams/asset-management/data-centers/index.vue'], resolve)
    },
    {
      path: '/ams/asset-management/data-centers/:dataCenterId',
      component: (resolve) =>
        require(['@/views/ams/asset-management/data-centers/Detail.vue'], resolve)
    },
    {
      path: '/ams/asset-management/system-option',
      component: (resolve) =>
        require(['@/views/ams/asset-management/system-option/index.vue'], resolve)
    },
    {
      path: '/ams/asset-management/system-option/:systemOptionId',
      component: (resolve) =>
        require(['@/views/ams/asset-management/system-option/Detail.vue'], resolve)
    },
    {
      path: '/ams/server-report/hardware-list',
      component: (resolve) =>
        require(['@/views/ams/server-report/hardware-list/index.vue'], resolve)
    },
    {
      path: '/ams/server-report/online-device-list',
      component: (resolve) =>
        require(['@/views/ams/server-report/online-device-list/index.vue'], resolve)
    },
    {
      path: '/ams/server-report/inventory-list',
      component: (resolve) =>
        require(['@/views/ams/server-report/inventory-list/index.vue'], resolve)
    },
    {
      path: '/ams/resource-management',
      component: (resolve) => require(['@/views/ams/resource-management/index.vue'], resolve),
      redirect: '/ams/resource-management/memory',
      children: [
        {
          path: '/ams/resource-management/memory',
          component: (resolve) =>
            require(['@/views/ams/resource-management/MemoryTab.vue'], resolve)
        },
        {
          path: '/ams/resource-management/cpu',
          component: (resolve) => require(['@/views/ams/resource-management/CpuTab.vue'], resolve)
        },
        {
          path: '/ams/resource-management/motherboard',
          component: (resolve) =>
            require(['@/views/ams/resource-management/MotherboardTab.vue'], resolve)
        },
        {
          path: '/ams/resource-management/chassis',
          component: (resolve) =>
            require(['@/views/ams/resource-management/ChassisTab.vue'], resolve)
        },
        {
          path: '/ams/resource-management/disk',
          component: (resolve) => require(['@/views/ams/resource-management/DiskTab.vue'], resolve)
        },
        {
          path: '/ams/resource-management/gpu',
          component: (resolve) => require(['@/views/ams/resource-management/GpuTab.vue'], resolve)
        }
      ]
    },
    {
      path: '/ams/inventory-management/purchase-list',
      component: (resolve) =>
        require(['@/views/ams/inventory-management/purchase/PurchaseList.vue'], resolve)
    },
    {
      path: '/ams/inventory-management/purchase/:purchaseId',
      redirect: '/ams/inventory-management/purchase/:purchaseId/particulars',
      component: (resolve) =>
        require(['@/views/ams/inventory-management/purchase/profile/index.vue'], resolve),
      children: [
        {
          path: '/ams/inventory-management/purchase/:purchaseId/particulars',
          component: (resolve) =>
            require([
              '@/views/ams/inventory-management/purchase/profile/particulars/index.vue'
            ], resolve)
        },
        {
          path: '/ams/inventory-management/purchase/:purchaseId/inventories',
          component: (resolve) =>
            require(['@/views/ams/inventory-management/purchase/profile/Inventories.vue'], resolve)
        },
        {
          path: '/ams/inventory-management/purchase/:purchaseId/activities',
          component: (resolve) =>
            require(['@/views/ams/inventory-management/purchase/profile/Activities.vue'], resolve)
        }
      ]
    },
    {
      path: '/ams/data-center-migration',
      name: 'AMS Data Center Migration',
      component: (resolve) => require(['@/views/ams/data-center-migration/index.vue'], resolve)
    }
  ]
};
